import React, { FC } from 'react'
import { Skeleton } from '@contrast-security-inc/design-system-loaders'
import { css } from '@emotion/css'

const notificationSkeletorStyles = css`
  padding: 20px;

  div:first-of-type {
    margin-bottom: 12px;
  }
`

export const NotificationSkeleton: FC = () => {
  return (
    <div
      className={notificationSkeletorStyles}
      data-testid="notification-skeletons"
    >
      <Skeleton shape="rectangle" borderRadius={2} height={16} width={244} />
      <Skeleton shape="rectangle" borderRadius={2} height={16} width={144} />
    </div>
  )
}
